import React, { useContext } from 'react';
import { TrackingStateContextType, TrackingStateProviderProps } from '../types';
import useTrackingStateContextValue from './useTrackingStateContextValue';

const TrackingStateContext = React.createContext<
  TrackingStateContextType | undefined
>(undefined);

export const TrackingStateProvider: React.FC<TrackingStateProviderProps> = ({
  children,
}) => (
  <TrackingStateContext.Provider value={useTrackingStateContextValue()}>
    {children}
  </TrackingStateContext.Provider>
);

export function useTrackingState() {
  const context = useContext(TrackingStateContext);

  if (context === undefined) {
    throw new Error(
      'useTrackingState must be used within TrackingStateProvider',
    );
  }

  return context;
}
